export enum AmnioticFluid {
	Clear = "0",
	WithLumps = "1",
	WithoutLumps = "2",
	Meconium = "3",
}

export const AmnioticFluidMessages = {
	[AmnioticFluid.Clear]: "Claro",
	[AmnioticFluid.WithLumps]: "Com grumos",
	[AmnioticFluid.WithoutLumps]: "Sem grumos",
	[AmnioticFluid.Meconium]: "Meconial",
};
